import React from 'react';
import './ErrorBoundary.css';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-boundary__inner">
            <div className="error-boundary__icon">⚠</div>
            <h1 className="error-boundary__title">Something went wrong</h1>
            <p className="error-boundary__sub">
              We're sorry — an unexpected error occurred. Please refresh the page or
              contact us if the problem persists.
            </p>
            <div className="error-boundary__actions">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => window.location.reload()}
              >
                Refresh Page
              </button>
              <a href="/contact" className="btn btn-outline-teal">
                Contact Support
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
